/* Shto cart: adds to the cart the way the store's own product page does, then opens their cart.
   Relaxe's theme is Prestige 3.1 with a cart drawer. Its product form POSTs /cart/add.js and then fires a "product:added"
   event; the theme's cart section listens for it, reloads the drawer and opens it. We do the same, so their cart, its
   upsells and the store's own add to cart tracking (Shopify's pixels see the /cart/add.js request) all work as usual.

   window.ShtoCart.add([{ id: variantId, quantity: 1 }]) -> Promise of Shopify's /cart/add.js answer.
   Several items go in one request. It rejects with Shopify's message (e.g. sold out) so the caller can show it. */
(function () {
  if (window.ShtoCart) return;

  function openCart(added) {
    var item = added && (added.items ? added.items[0] : added);
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: { variant: item ? { id: item.variant_id || item.id } : null, quantity: item ? item.quantity : 1 }
    }));
  }

  window.ShtoCart = {
    open: openCart,
    add: function (items) {
      var body = items.length === 1 ? items[0] : { items: items };
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart');
          return d;
        });
      }).then(function (added) { openCart(added); return added; });
    }
  };
})();
